export {preset, type PresetConfig} from './preset.js';
export {getSchema} from './schema.js';
export {
  type ClientReturn,
  type ClientVariables,
  type ClientVariablesInRestParams,
  type EmptyVariables,
  type GenericVariables,
  type IsOptionalVariables,
  pluckConfig,
  plugin,
  processSources,
} from '@shopify/graphql-codegen';
